import React, { useMemo } from "react";

import { faCheck, faQuestion, faTimes } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import Avatar, { type UserAvatarProps } from "~/ui/avatar/Avatar";

import styles from "./AttendeeStatusAvatar.module.css";

interface AttendeeStatusAvatarProps extends Pick<UserAvatarProps, "user" | "size" | "outline"> {
	responseStatus: string;
	dimmed?: boolean;
	className?: string;
}

export default function AttendeeStatusAvatar({
	user,
	size,
	responseStatus: responseStatusProp,
	className,
}: AttendeeStatusAvatarProps) {
	const responseStatus = useMemo(() => {
		if (responseStatusProp === "accepted") return "accepted" as const;
		if (responseStatusProp === "declined") return "declined" as const;
		if (responseStatusProp === "tentative" || responseStatusProp === "tentativelyAccepted") return "tentative" as const;
		return "unknown" as const;
	}, [responseStatusProp]);

	let status: React.ReactNode = <div className={cx(styles.statusIcon, styles.placeholder)} />;

	if (responseStatus === "accepted") {
		status = (
			<div className={cx(styles.statusIcon, styles.attending)}>
				<FontAwesomeIcon icon={faCheck} />
			</div>
		);
	} else if (responseStatus === "declined") {
		status = (
			<div className={cx(styles.statusIcon, styles.declined)}>
				<FontAwesomeIcon icon={faTimes} />
			</div>
		);
	} else if (responseStatus === "tentative") {
		status = (
			<div className={cx(styles.statusIcon, styles.tentative)}>
				<FontAwesomeIcon icon={faQuestion} />
			</div>
		);
	}

	return (
		<div className={cx(styles.container, className)}>
			<Avatar user={user} size={size} outline="solid" />
			{status}
		</div>
	);
}
